import { AgGridReact } from 'ag-grid-react'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Card, Col, Modal, Row } from 'react-bootstrap'
import { academydetail, feeinvoicelist, feesummarylist } from '../../../services/admin';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

export const FeeList = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [filterProduct, setFilterProduct] = useState([]);
    const [academy, setAcademy] = useState("");

    const columnDefs = [
        {
            headerName: "Invoice",
            width: 100,
            field: "id",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: false,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a title='Invoice Bill' onClick={() => checkinv(id)}
                            // onClick={() => navigate(`/feemodule/invoice/${id}/${params.value}`)}
                            className="btn-sm btn-info"
                        >
                            <i className="fas fa-file-invoice"></i>
                        </a>

                    </div>
                );
            }
        },
        {
            headerName: "User Name",
            width: 200,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Student Name",
            width: 200,
            field: "full_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            width: 120,
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            width: 120,
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Year",
            width: 200,
            field: "aca_year",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Fee Type",
            width: 200,
            field: "fee_type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Paid Date",
            width: 200,
            field: "payment_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return (
                        moment(params.value).format("DD-MM-YYYY")
                    );
                }

            }
        },
        {
            headerName: "Total Amount",
            width: 150,
            field: "total_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Paid Amount",
            width: 150,
            field: "payment_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Payment Type",
            width: 200,
            field: "payment_method",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];

    useEffect(() => {
        feesummarylist(id).then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });

        if (localStorage.getItem("AAcademy") != null) {
            academydetail(localStorage.getItem("AAcademy")).then((res) => {
                if (res.status === true) {
                    if (res.data.details.name !== null) {
                        console.log(res.data.details);
                        setAcademy(res.data.details);
                    } else {
                        setAcademy("");
                    }
                }
            });
        }
    }, []);


    const [show, setShow] = useState(false);
    const [invdata, setInvData] = useState([]);
    const [invno, setInvNo] = useState("");
    const checkinv = (did) => {
        const temp = new FormData();
        temp.append("fee_id", did);
        // temp.append("payment_date", ddate);
        feeinvoicelist(temp).then((res) => {
            if (res.status === true) {
                if (res.status === true && Array.isArray(res.data) && res.data.length > 0) {
                    setShow(true);
                    setInvData(res.data);
                    setInvNo(res.data[0]);
                } else {
                    // handle empty or invalid data here
                }
            }
        });
    }
    const printRef = useRef();
    const cellStyle = {
        border: "1px solid #ccc",
        padding: "8px",
    };
    const handlePrinting = () => {
        // window.print();
        setShow(false);
        const printContents = printRef.current.innerHTML;
        const printWindow = window.open('', '', 'height=700,width=900');
        printWindow.document.write(`
          <html>
            <head>
              <title>Fee Receipt</title>
              <style>
                body {
                  font-family: Arial, sans-serif;
                  padding: 20px;
                }
                .receipt {
                  width: 600px;
                  margin: 0 auto;
                  border: 1px solid #ccc;
                  padding: 20px;
                }
                  .avatar-upload .avatar-preBoopathi img{
                  text-align: center;
                  }
                h2, p {
                  text-align: center;
                  margin: 0;
                  padding: 5px;
                }
                table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-top: 20px;
                }
                th, td {
                  border: 1px solid #ccc;
                  padding: 8px;
                  text-align: left;
                }
                .total {
                  font-weight: bold;
                }
                .right {
                  text-align: right;
                }
                .signature {
                  margin-top: 40px;
                  text-align: right;
                }
                .note {
                  margin-top: 30px;
                  font-size: 12px;
                }
              </style>
            </head>
            <body>
              ${printContents}
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        // printWindow.close();

        setTimeout(() => {
            printWindow.close();
        }, 1000);
    };
    const totalAmount = invdata.reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0);
    const amountInWords = numberToWords(Math.floor(totalAmount));

    function numberToWords(num) {
        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
            "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty",
            "Sixty", "Seventy", "Eighty", "Ninety"];

        const convertTens = (n) => {
            if (n < 10) return ones[n];
            if (n < 20) return teens[n - 10];
            return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        };

        let result = "";

        if (num >= 1000) {
            const thousands = Math.floor(num / 1000);
            result += convertTens(thousands) + " Thousand ";
            num %= 1000;
        }

        if (num >= 100) {
            result += ones[Math.floor(num / 100)] + " Hundred ";
            num %= 100;
        }

        if (num > 0) {
            if (result !== "") result += "and ";
            result += convertTens(num);
        }

        return result.trim() + " Rupees Only";
    }


    return (
        <Fragment>
            <div className="page-header reported-header">
                <div>
                    <h2 className="main-content-title tx-24 mg-b-5">
                        Fee Summary List
                    </h2>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a>Fee Module</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Fee Summary List
                        </li>
                    </ol>
                </div>
            </div>
            <Row className="row-sm mx-0 mt-3">
                <Col xxl={12} lg={12} md={12}>
                    <Card className="custom-card overflow-hidden">
                        <Card.Body>
                            <div className='text-right'>
                                <a className='btn btn-secondary' onClick={() => navigate(`/feemodule/allfee`)}>Back</a>
                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>
                            <Modal size="lg"
                                show={show}>
                                <Modal.Header>Invoice</Modal.Header>
                                <Modal.Body>
                                    <div ref={printRef} className="receipt">
                                        {/* Header with logo and school name */}
                                        <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "20px" }}>
                                            <img src={require("../../../assets/images/logo/logo.png")} alt="Logo" style={{ height: "80px" }} />
                                            <div>
                                                <h2 style={{ margin: 0 }}>{academy.name}</h2>
                                                <p style={{ margin: 0 }}>
                                                    {academy.address}
                                                </p>
                                            </div>
                                        </div>

                                        {/* Student Info */}
                                        <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr>
                                                    <td><b>Admission No:</b> {invno.admission_number}</td>
                                                    <td><b>Student Name:</b> {invno.full_name}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Class:</b> {invno.class_name} - {invno.section_name}</td>
                                                    <td><b>Roll No:</b>{invno.roll_number}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Receipt No:</b> {invno.inv_no}</td>
                                                    <td><b>Receipt Date:</b> {moment(invno.payment_date).format("DD-MM-YYYY")}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* Fee Details */}
                                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                            <thead>
                                                <tr style={{ backgroundColor: "#f2f2f2" }}>
                                                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Particulars</th>
                                                    <th style={{ border: "1px solid #ccc", padding: "8px" }}>Amount (₹)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {invdata.map((fee, index) => (
                                                    <tr key={index}><td style={cellStyle}>{fee.fee_type}{fee.fee_month ? " (" + moment(fee.fee_month, "YYYY-MM").format("MMMM YYYY") + ")" : ""}</td><td style={cellStyle}>{parseFloat(fee.payment_amount).toFixed(2)}</td></tr>

                                                ))}
                                                <tr style={{ fontWeight: "bold" }}>
                                                    <td style={cellStyle}>Total</td>
                                                    <td style={cellStyle}> {invdata
                                                        .reduce((total, fee) => total + parseFloat(fee.payment_amount || 0), 0)
                                                        .toFixed(2)}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <p style={{ marginTop: "20px" }}><b>In Words:</b> {amountInWords}</p>
                                        <p><b>Payment Mode:</b> Cash</p>
                                         <div style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "30px",
                    }}>
                      <p style={{ fontWeight: "bold", margin: 0 ,fontSize:"14px"}}>
                        Please note: Paid fees will not be refunded under any circumstances.
                      </p>

                      <b>Signature</b>
                    </div>

                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <a className="btn btn-danger" onClick={() => setShow(false)}>
                                        Close
                                    </a>
                                    <button className="btn btn-success" onClick={handlePrinting}>
                                        Print
                                    </button>
                                </Modal.Footer>
                            </Modal>

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Fragment>
    )
}
